import { Checkbox, DatePicker, Form, Input, Schema,InputPicker } from 'rsuite';
import React, { useState } from 'react';
import AuthService from "../../../services/auth.service"
import { useNavigate } from "react-router-dom"
import { Col, Row } from 'react-bootstrap';
import { titleData, suffixData } from '../../../fakeapi';
import YesNoRadioOption from '../../Shared/RadioButton/YesNoRadioOption';
import RedStar from '../../Shared/GenericComponents/RedStar';
import { getCountries, getStates } from '../../../services/Shared/codeTable.service'
import { useEffect } from 'react';
import LoadingSpinner from '../../Shared/GenericComponents/LoadingSpinner';
import { PatternFormat } from 'react-number-format';
import Swal from 'sweetalert2';
import { AccessibleInputPicker } from '../../Shared/GenericComponents/AccessibleComponents';

const InputMask = ({ onChange, ...rest }) => {
    return (
        <PatternFormat
            {...rest}
            className="form-control"
            onChange={event => {
                onChange(event.target.value);
            }}
        />
    );
};

function IndividualForm() {
    const [state, setState] = useState({
        firstName: "",
        middleName: "",
        lastName: "",
        title: '',
        suffix: '',
        social: '',
        confirmSocial: '',
        userName: '',
        email: "",
        confirmEmail: "",
        dateOfBirth: null,
        birthCity: '',
        birthState: null,
        stateProvinceRegion: '',
        maidenName: '',
        birthCountry: { id: 221, code: 'US', country: "United States" }, //US Default
        password: "",
        confirmPassword: "",
        isUsCitizen: '',
        citizenshipCountry: null,
    });
    const [countries, setCountries] = useState([])
    const [inputType, setInputType] = useState("text");
    const [showPass, toggleShowPass] = useState(false);
    const [states, setStates] = useState([])
    const [hasLoaded, setHasLoaded] = useState(false)

    useEffect(() => {
        getCountries().then(setCountries);
        getStates().then(setStates);

        setHasLoaded(true)

    }, [])
    const history = useNavigate();
    const { StringType, BooleanType, ObjectType, DateType } = Schema.Types;
    const model = Schema.Model({
        firstName: StringType().isRequired('This field is required.'),
        lastName: StringType().isRequired('This field is required.'),
        dateOfBirth: DateType('Please enter a valid date').isRequired('This field is required.'),
        birthCity: StringType().isRequired('This field is required.'),
        birthCountry: ObjectType().isRequired('This field is required.'),
        isUsCitizen: BooleanType().isRequired('This field is required.'),
        title: StringType().isRequired('This field is required.'),
        social: StringType().isRequired('This field is required.').pattern(/^[0-9]{3}-[0-9]{2}-[0-9]{4}$/, "Please enter a vaild SSN"),
        confirmSocial: StringType().isRequired('This field is required.').addRule((value, data) => {
            if (value !== data.social) {
                return false;
            }
            return true;
        }, "SSNs don't match"),
        userName: StringType().pattern(/^[0-9a-zA-Z]+$/, "Invalid characters in username. Please use numbers or letters only.").isRequired('This field is required.'),
        email: StringType().isRequired('This field is required.').isEmail("This is not a valid Email."),
        confirmEmail: StringType().isRequired('This field is required.').addRule((value, data) => {
            if (value !== data.email) {
                return false;
            }
            return true;
        }, "Emails don't match").isEmail("This is not a valid Email."),
        password: StringType().pattern(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$ %^&*\-_]).{8,}$/, 'Password requires a minimum of 8 characters using upper and lower case letters, and at least 1 number and 1 symbol').isRequired('This field is required.'),
        confirmPassword: StringType().isRequired('This field is required.').addRule((value, data) => {
            if (value !== data.password) {
                return false;
            }
            return true;
        }, "Passwords don't match"),
        birthState: ObjectType().when(schema => {
            const { value } = schema.birthCountry;
            return value?.id === 221 ? ObjectType().isRequired('This field is required') : ObjectType();
        }),
        citizenshipCountry: ObjectType().when(schema => {
            const { value } = schema.isUsCitizen;
            return value === false ? ObjectType().isRequired('This field is required') : ObjectType();
        })
    })

    const handleIndividualFormSubmit = (validation, event) => {
        AuthService.registerIndividual(state).then(
            (data) => {
                if (data.data.isSuccess) {
                    history("/registerSuccess");
                }
            },
            (error) => {
                const resMessage =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();
                Swal.fire("Error", resMessage, "error");
            }
        );
    }
    return (
        <Form id="individualForm" fluid model={model} formValue={state} onChange={state => setState(state)} onSubmit={handleIndividualFormSubmit}>
            {hasLoaded ? <>
                <Row className="mb-4 pb-1">
                    <Col>
                        <Form.Group>
                            <Form.ControlLabel className='d-none'>First name</Form.ControlLabel>
                            <Form.Control name="firstName" placeholder="First Name" tabIndex="1" />
                            <Form.HelpText className='d-none'>Enter first name</Form.HelpText>
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group>
                            <Form.ControlLabel className='d-none'>Date of Birth</Form.ControlLabel>
                            <Form.Control
                                accepter={DatePicker}
                                format="MM/dd/yyyy"
                                name="dateOfBirth"
                                placeholder="Date of Birth"
                                oneTap
                                block={true}
                                tabIndex="7"
                            />
                            <Form.HelpText className='d-none'>Enter date of birth in MM/dd/yyyy format</Form.HelpText>
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group>
                            <Form.ControlLabel className='d-none'>Email</Form.ControlLabel>
                            <Form.Control
                                type="email"
                                placeholder="Email"
                                name="email"
                                checkTrigger="blur"
                                tabIndex="12" />
                            <Form.HelpText className='d-none'>Enter an email</Form.HelpText>
                        </Form.Group>
                    </Col>

                </Row>
                <Row className="mb-4 pb-1">
                    <Col>
                        <Form.Group>
                            <Form.ControlLabel className='d-none'>Middle Name</Form.ControlLabel>
                            <Form.Control name="middleName" placeholder="Middle Name (birth name)" tabIndex="2" />
                            <Form.HelpText className='d-none'>Enter a middle name (optional)</Form.HelpText>
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group>
                            <Form.ControlLabel className='d-none'>Country of Birth</Form.ControlLabel>
                            <Form.Control
                                block={true}
                                name="birthCountry"
                                placeholder="Country of Birth"
                                accepter={AccessibleInputPicker}
                                ariaLabel="Pick a Country"
                                data={countries}
                                tabIndex="8" />
                            <Form.HelpText className='d-none'>Pick a Country.</Form.HelpText>
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group>
                            <Form.ControlLabel className='d-none'>Confirm Email</Form.ControlLabel>
                            <Form.Control
                                type="email"
                                placeholder="Confirm Email"
                                name="confirmEmail"
                                checkTrigger="blur"
                                tabIndex="13" />
                            <Form.HelpText className='d-none'>Confirm email</Form.HelpText>
                        </Form.Group>
                    </Col>

                </Row>
                <Row className="mb-4 pb-1">
                    <Col>
                        <Form.Group>
                            <Form.ControlLabel className='d-none'>Last Name</Form.ControlLabel>
                            <Form.Control
                                name="lastName"
                                placeholder="Last Name (Surname/Family Name)"
                                tabIndex="3" />
                            <Form.HelpText className='d-none'>Enter a last name</Form.HelpText>
                        </Form.Group>
                    </Col>
                    <Col>

                        <Form.Group>
                            <Form.ControlLabel className='d-none'>State/Province/Region of Birth</Form.ControlLabel>
                            {state.birthCountry?.id === 221 &&
                                <Form.Control
                                accepter={AccessibleInputPicker}
                                    ariaLabel="Enter a state/province/region of birth"
                                    placeholder="State of Birth"
                                    block={true}
                                    data={states}
                                    searchBy={(userInput, label, dataItem) => { if (label.toLowerCase().startsWith(userInput.toLowerCase()) || !userInput) return true; }}
                                    name="birthState"
                                    tabIndex="9" />
                            }
                            {state.birthCountry?.id !== 221 &&
                                <Form.Control
                                    placeholder="State/Province/Region of Birth"
                                    name="stateProvinceRegion"
                                    tabIndex="9" />
                            }
                            <Form.HelpText className='d-none'>Enter a state/province/region of birth.</Form.HelpText>
                        </Form.Group>

                    </Col>
                    <Col>
                        <Form.Group>
                            <Form.ControlLabel className='d-none'>SSN</Form.ControlLabel>
                            <Form.Control
                                accepter={InputMask}
                                placeholder="SSN"
                                name="social"
                                format="###-##-####"
                                mask="_"
                                tabIndex="13" />
                            <Form.HelpText className='d-none'>Enter a SSN.</Form.HelpText>
                        </Form.Group>
                    </Col>

                </Row>
                <Row className="mb-4 pb-1">
                    <Col>
                        <Form.Group>
                            <Form.ControlLabel className='d-none'>Maiden Name</Form.ControlLabel>
                            <Form.Control
                                placeholder="Maiden Name (if different from last name)"
                                name="maidenName"
                                tabIndex="4" />
                            <Form.HelpText className='d-none'>Enter a maiden name (optional).</Form.HelpText>

                        </Form.Group>
                    </Col>

                    <Col>
                        <Form.Group>
                            <Form.ControlLabel className='d-none'>City of Birth</Form.ControlLabel>
                            <Form.Control name="birthCity" placeholder="City of Birth" tabIndex="10" />
                            <Form.HelpText className='d-none'>Enter a city of birth</Form.HelpText>
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group>
                            <Form.ControlLabel className='d-none'>Confirm SSN</Form.ControlLabel>
                            <Form.Control
                                accepter={InputMask}
                                placeholder="Confirm SSN"
                                name="confirmSocial"
                                format="###-##-####"
                                mask="_"
                                tabIndex="14" />
                            <Form.HelpText className='d-none'>Confirm SSN.</Form.HelpText>
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col >
                        <Form.Group>
                            <Form.ControlLabel className='d-none'>Title</Form.ControlLabel>
                            <Form.Control
                                accepter={AccessibleInputPicker}
                                ariaLabel="Select a Title"
                                placeholder="Title"
                                data={titleData}
                                block={true}
                                name="title"
                                tabIndex="5" />
                            <Form.HelpText className='d-none'>Select a title</Form.HelpText>
                        </Form.Group>
                    </Col>
                    <Col >
                        <Form.Group>
                            <Form.ControlLabel className='d-none'>Suffix</Form.ControlLabel>
                            <Form.Control
                                placeholder="Suffix"
                                data={suffixData}
                                name="suffix"
                                block={true}
                                accepter={AccessibleInputPicker}
                                ariaLabel="Select a suffix (optional)"
                                tabIndex="6" />
                            <Form.HelpText className='d-none'>Select a suffix (optional)</Form.HelpText>

                        </Form.Group>
                    </Col>
                    <Col sm={4}>
                        <Row>
                            <Col sm={5}>
                                <strong>
                                    Are you a<br />U.S. Citizen?<RedStar />
                                </strong>
                            </Col>
                            <Col>
                                <YesNoRadioOption radioName="isUsCitizen" tabIndex="11" />
                            </Col>
                        </Row>
                    </Col>
                    <Col sm={4}>
                        {state.isUsCitizen === false &&
                            <Form.Group>
                                <Form.ControlLabel className='d-none'>Citizenship Country</Form.ControlLabel>
                                <Form.Control
                                    block={true}
                                    name="citizenshipCountry"
                                    placeholder="If no, what country?"
                                    accepter={AccessibleInputPicker}
                                    ariaLabel="Citizenship Country"
                                    data={countries} />
                                <Form.HelpText className='d-none'>Citizenship Country</Form.HelpText>
                            </Form.Group>
                        }
                    </Col>
                </Row>

                <br />
                <hr />
                <Row>
                    <Col>
                        <Form.Group>
                            <Form.ControlLabel className='d-none'>User Id</Form.ControlLabel>
                            <Form.Control
                                placeholder="User Id"
                                name="userName"
                                tabIndex="15"
                                errorPlacement="topStart" />
                            <Form.HelpText className='d-none'>Enter a user name</Form.HelpText>

                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group>
                            <Form.ControlLabel className='d-none'>Password</Form.ControlLabel>
                            <Form.Control
                                type={showPass ? "text" : "password"}
                                placeholder="Password"
                                checkTrigger="blur"
                                name="password"
                                tabIndex="16"
                                title="Password requires a minimum of 8 characters using upper and lower case letters, and at least 1 number and 1 symbol"
                                errorPlacement="topStart" />
                            <Form.HelpText className='d-none'>Enter a password</Form.HelpText>
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group>
                            <Form.ControlLabel className='d-none'>Confirm Password</Form.ControlLabel>
                            <Form.Control
                                type={showPass ? "text" : "password"}
                                placeholder="Confirm Password"
                                checkTrigger="blur"
                                name="confirmPassword"
                                tabIndex="17"
                                errorPlacement="bottomStart" />
                            <Form.HelpText className='d-none'>Confirm password</Form.HelpText>
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col></Col>
                    <Col>
                        <Checkbox onChange={() => { toggleShowPass(!showPass) }} tabIndex={18}>Show Password</Checkbox>
                    </Col>
                    <Col></Col>
                </Row>
            </> : <LoadingSpinner />}
        </Form>
    );
}
export default IndividualForm;






